// extracted by mini-css-extract-plugin
export default {"root":"TextImage__root___cT-Bp"};